import { Edition } from "@environments/edition.interface";

export const edition: Edition = {
  mode: "customerAndStaff",
};
